<template>
    <section id="animais" class="section py-20 bg-primaryLight">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col lg:flex-row items-center">
                <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                    <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">Encontro com a Vida Selvagem</h2>
                    <p class="text-lg text-white mb-6">Conheça de perto os encantadores animais que fazem parte da experiência única do nosso resort.</p>
                    <p class="text-lg text-white mb-8">Ideal para crianças e adultos, nossos espaços são pensados para interação e aprendizado sobre a vida no campo.</p>
                    <div class="bg-white/20 backdrop-blur-sm p-6 rounded-lg">
                        <div class="flex items-center mb-4">
                            <i class="fas fa-paw text-white text-xl mr-3"></i>
                            <span class="text-white font-semibold">Trilhas e Contato Animal</span>
                        </div>
                        <p class="text-white">Aventure-se em trilhas com paisagens naturais e encontre animais como cavalos, coelhos e aves exóticas.</p>
                    </div>
                </div>

                <!-- Carrossel -->
                <div class="lg:w-1/2">
                    <Swiper :modules="[Grid, Autoplay]" :slides-per-view="2" :grid="{ rows: 2, fill: 'row' }" :space-between="24" :loop="images.length > 4" :autoplay="images.length > 4 ? { delay: 4000, disableOnInteraction: false } : false" class="w-full p-4 bg-transparent">
                        <SwiperSlide v-for="(image, index) in images" :key="index" class="overflow-visible">
                            <img :src="image.src" :alt="image.alt" class="w-full h-72 object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out
                                hover:scale-110 hover:z-10 will-change-transform" style="transform-origin: center center;" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <div class="grid md:grid-cols-3 gap-8 mt-12">
                <div class="text-center">
                    <div class="bg-lime-700 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-horse text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Passeios a Cavalo</h3>
                    <p class="text-gray-200">Trilhas tranquilas montado em nossos cavalos treinados, ideais para todas as idades.</p>
                </div>
                <div class="text-center">
                    <div class="bg-lime-700 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-paw text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Interação com Animais</h3>
                    <p class="text-gray-200">Toque, alimente e conheça de perto coelhos, cabras e aves do nosso mini zoológico.</p>
                </div>
                <div class="text-center">
                    <div class="bg-lime-700 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-binoculars text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Observação da Fauna</h3>
                    <p class="text-gray-200">Veja animais silvestres em seu habitat natural, com total respeito ao meio ambiente.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Grid } from 'swiper/modules';

const images = [
    { src: new URL('../../assets/images/bg/resort-animais.jpg', import.meta.url).href, alt: 'Adega de vinhos' },
    { src: new URL('../../assets/images/bg/resort-animais2.jpg', import.meta.url).href, alt: 'Taças de vinho' },
    { src: new URL('../../assets/images/bg/resort-animais3.jpg', import.meta.url).href, alt: 'Degustação de vinho' },
    { src: new URL('../../assets/images/bg/resort-animais4.jpg', import.meta.url).href, alt: 'Garrafas de vinho' },
    { src: new URL('../../assets/images/bg/resort-animais5.jpg', import.meta.url).href, alt: 'Vista panorâmica' },
    { src: new URL('../../assets/images/bg/resort-animais.jpg', import.meta.url).href, alt: 'Área de lazer' },
];
</script>
